import { AxiosInstance } from 'axios';
import { BaseApi } from 'services/api/base-api';
import { ApiResult } from 'services/api/result.type';
import { GetReceiptResponse } from './dto';

export type CheckInStatus =
  | 'checked_in'
  | 'already_checked_in'
  | 'already_used'
  | 'invalid'
  | 'unverified'
  | 'rsvp_required'
  | 'not_open'
  | 'not_started'
  | 'closed'
  | 'cancelled'
  | 'not_found'
  | 'disabled'
  | 'self_blocked'
  | 'outside_guest'
  | 'see_organizer'
  | 'rate_limited';
export type CheckInMethod = 'self_scan' | 'staff_scan' | 'email';

export interface CheckInTicketIdentity {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  ticketNumber?: string;
  ticketType?: string;
}

export interface CheckInResult {
  status: CheckInStatus;
  checkedInAt?: string;
  method?: CheckInMethod;
  ticket?: CheckInTicketIdentity;
  eventName?: string;
  checkInOpensAt?: string;
  checkInClosesAt?: string;
  allowWalkInCheckIn?: boolean;
  isGuest?: boolean;
  isWalkIn?: boolean;
}

export class ReceiptsApi extends BaseApi {
  public constructor(protected readonly api: AxiosInstance) {
    super();

    this.getReceipt = this.getReceipt.bind(this);
  }

  public async getReceipt(id: string): ApiResult<GetReceiptResponse> {
    return await this.get<GetReceiptResponse>(`/receipts/${id}`);
  }

  public async checkIn(eventId: string): ApiResult<CheckInResult> {
    return await this.put(`/receipts/checkin/${eventId}`);
  }

  public async checkInAttendee(
    eventId: string,
    userId: string,
    confirmGuest = false,
  ): ApiResult<CheckInResult> {
    const query = confirmGuest ? '?confirmGuest=true' : '';
    return await this.put(
      `/receipts/checkin/${eventId}/${userId}${query}`,
      null,
    );
  }
}
